// extracted by mini-css-extract-plugin
export default {"buttonMenuMore":"ButtonMenuMore_buttonMenuMore__4fBDR","badge":"ButtonMenuMore_badge__uVp+t","dropDown":"ButtonMenuMore_dropDown__r3bPW","itemList":"ButtonMenuMore_itemList__t1ZNg"};